import React from 'react';
import './DynaButton.scss';

const SimpleButton = (props) => {

    return (
        <button
            id={props.id !== undefined ? props.id : undefined}
            type={props.type !== undefined ? props.type : undefined}
            disabled={props.disabled !== undefined ? props.disabled : undefined}
            style={props.style !== undefined ? props.style : undefined}
            onChange={props.onChange !== undefined ? props.onChange : undefined}
            onClick={props.onClick !== undefined ? props.onClick : undefined}
            className={props.className !== undefined ? props.className : undefined}>
            {props.children}
        </button>
    );
};

export default SimpleButton;